import React from "react";
import { Button, TextInput, Container, Text, Loader, Paper } from "@mantine/core";
import { notifications } from "@mantine/notifications";
import { useNavigate } from "react-router-dom";
import apiService from "services/ApiService.js";
import { useTrans } from "core";
import { Api_ConfirmReserve } from "../../../constants/SubApi.js";
import getLocalizedField from "services/getLocalizedField.js";

export default function ConfirmReservation() {
	const [reservationCode, setReservationCode] = React.useState("");
	const [loading, setLoading] = React.useState(false);
	const [reservationData, setReservationData] = React.useState(null);
	const navigate = useNavigate();
	const { t } = useTrans();

	const notify = (msg, color = "blue") => notifications.show({ message: msg, color });

	const fetchReservation = async () => {
		if (!reservationCode.trim()) {
			notify("Please enter reservation code", "red");
			return;
		}

		setLoading(true);
		setReservationData(null);

		try {
			const res = await apiService.get(`${Api_ConfirmReserve}?code=${encodeURIComponent(reservationCode.trim())}`);

			setReservationData(res);
			notify("Reservation data loaded successfully", "green");
		} catch (err) {
			notify("Failed to load reservation", "red");
		}

		setLoading(false);
	};

	const submitData = async () => {
		if (!reservationData) return;
		setLoading(true);

		try {
			const pdfBlob = await apiService.post(
				`/${Api_ConfirmReserve}`,
				{ id: reservationData.id },
				{ responseType: "blob" }
			);
			const blob = pdfBlob.type ? pdfBlob : new Blob([pdfBlob], { type: "application/pdf" });
			const blobUrl = URL.createObjectURL(blob);
			const newWindow = window.open();
			if (newWindow) {
				newWindow.location.href = blobUrl;
			} else {
				const a = document.createElement("a");
				a.href = blobUrl;
				a.download = `receipt-${reservationData.id}.pdf`;
				document.body.appendChild(a);
				a.click();
				a.remove();
			}

			notify("PDF opened successfully", "green");

			// revoke the object URL after a short delay to allow the browser to load it
			setTimeout(() => URL.revokeObjectURL(blobUrl), 30_000);
		} catch (err) {
			console.error("Error generating/opening PDF", err);
			notify("Error generating PDF", "red");
		}

		setLoading(false);
	};

	return (
		<Container size="sm" mt={40}>
			<Paper withBorder shadow="md" p="lg" radius="md">
				{!reservationData ? (
					<div key="step1">
						<TextInput
							label={t("confirmReserveation.confirmReserve")}
							placeholder={t("confirmReserveation.reserveCode")}
							value={reservationCode}
							onChange={(e) => setReservationCode(e.target.value)}
							size="md"
							radius="md"
							styles={{ label: { color: "white" } }}
						/>

						<Button fullWidth mt="lg" size="md" radius="md" onClick={fetchReservation} disabled={loading}>
							{loading ? <Loader size="sm" color="white" /> : t("confirmReserveation.fetchData")}
						</Button>
					</div>
				) : (
					<div key="step2" style={{ textAlign: "center" }}>
						<Text>
							{t("bookApartment.total")}: {reservationData.totalPrice}{" "}
							{getLocalizedField(reservationData, "currency_name")}
						</Text>

						<Text mt="md">{t("confirmReserveation.reserveQuestion")}</Text>

						<Button fullWidth mt="lg" size="md" radius="md" onClick={submitData} disabled={loading}>
							{loading ? <Loader size="sm" color="white" /> : t("confirmReserveation.confirmReserve")}
						</Button>

						<Button fullWidth variant="default" mt="lg" size="md" radius="md" onClick={() => navigate("/")}>
							{t("region.cancel")}
						</Button>
					</div>
				)}
			</Paper>
		</Container>
	);
}
